import { WalletType } from '~/shared';
import { IShopPreviewProps, VariationMode } from '~/components/ui/ShopPreview';
import { setCount, useLayoutDispatch, useLayoutSelector } from '../redux';
import { useBuy } from './useBuy';

const MAX_COUNT = 99;

const useShopPreview = (): IShopPreviewProps => {
	const dispatch = useLayoutDispatch();
	const activeItem = useLayoutSelector((state) => state.productShop.activeItem);
	const count = useLayoutSelector((state) => state.productShop.count);
	const { handleBuy } = useBuy();

	const handleChangeCount = (newCount: number) => {
		if (newCount >= 0 && newCount < MAX_COUNT) {
			dispatch(setCount(newCount));
		}
	};

	if (!activeItem) {
		return {
			visible: false,
			name: '',
			price: 0,
		};
	}

	return {
		visible: true,
		name: activeItem.name,
		price: activeItem.price,
		walletType: activeItem.walletType,
		variationIndex: count,
		maxVariantIndex: MAX_COUNT,
		onVariationChange: handleChangeCount,
		handlePayByCash: () => handleBuy(WalletType.Cash),
		handlePayByCard: () => handleBuy(WalletType.Bank),
		handlePayByDonate: () => handleBuy(WalletType.Donate),
		variationMode: VariationMode.Count,
		variationTitle: 'Количество',
	};
};

export { useShopPreview };
